var _defs, _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavWalletIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.6 52.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffc139;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-width: 3.13px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.57,
    y: 1.57,
    width: 48.35,
    height: 42.15,
    rx: 6.53,
    ry: 6.53
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.57,
    y: 8.71,
    width: 54.47,
    height: 42.15,
    rx: 6.53,
    ry: 6.53
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.29,23.65h11.74v12.26h-11.74c-3.38,0-6.13-2.75-6.13-6.13h0c0-3.38,2.75-6.13,6.13-6.13Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.64,
    cy: 29.78,
    r: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavWalletIconBlack);
export default __webpack_public_path__ + "static/media/nav-wallet-icon-black.76811963add0437c270e84c57ef9c651.svg";
export { ForwardRef as ReactComponent };